import * as S from './styles'

import CountdownCard from '../countdownCard'
import usePlayerCountdown from '../../../../hooks/usePlayerCountdown'
import { Transmission } from 'modules/transmission/types'

export interface PlayerThumbProps {
  hideCountdown: boolean,
  transmission: Transmission,
  className?: string
}

const PlayerThumb = ({ transmission, hideCountdown, className }: PlayerThumbProps) => {
  const { countdownMessage, formattedDate } = usePlayerCountdown(
    transmission.liveStartAt,
    transmission.zoneId
  )

  return (
    <S.Container className={className} data-test="player-thumb">
      <S.ThumbImg src={transmission.largeThumbnailLink} data-test="thumb-img"/>
      {!hideCountdown && (
        <CountdownCard remainingTime={countdownMessage} formattedDate={formattedDate} />
      )}
    </S.Container>
  )
}

export default PlayerThumb
